import { Error, Group, Label, Textarea as BaseTextarea } from '@/Components/UI/Form/Partials';
import { useFormInput } from '@/hooks';
import { FormInputProps } from '@/types';

type InputProps = FormInputProps<HTMLTextAreaElement>;

export const Textarea = ({
                             id,
                             name,
                             label,
                             required = false,
                             disabled = false,
                             groupClassName,
                             ...rest
                         }: InputProps) => {
    const { value, setValue, error } = useFormInput<string>(name);

    return (
        <Group className={groupClassName}>
            <Label
                htmlFor={id ?? name}
                required={required}
                disabled={disabled}
                invalid={error !== undefined}>
                {label}
            </Label>

            <BaseTextarea
                {...rest}
                id={id ?? name}
                name={name}
                value={value ?? ''}
                onChange={(e) => setValue(e.target.value)}
                invalid={error !== undefined} />

            <Error error={error} />
        </Group>
    );
};
